var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "groups_black_24dp_1_",
    "data-name": "groups_black_24dp (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1495",
    "data-name": "Rectangle 1495",
    width: 40,
    height: 40,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6782",
    "data-name": "Group 6782",
    transform: "translate(0 9.858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M6.572,17.5a3.286,3.286,0,1,0-3.286-3.286A3.3,3.3,0,0,0,6.572,17.5Zm1.856,1.807a11.472,11.472,0,0,0-1.856-.164A11.419,11.419,0,0,0,2,20.1a3.3,3.3,0,0,0-2,3.039v2.579H7.393V23.07A7.391,7.391,0,0,1,8.428,19.308ZM32.858,17.5a3.286,3.286,0,1,0-3.286-3.286A3.3,3.3,0,0,0,32.858,17.5Zm6.572,5.635a3.3,3.3,0,0,0-2-3.039A11.169,11.169,0,0,0,31,19.308a7.391,7.391,0,0,1,1.035,3.762v2.645H39.43ZM26.681,18.568a17.157,17.157,0,0,0-6.966-1.479,17.433,17.433,0,0,0-6.966,1.479,4.909,4.909,0,0,0-2.892,4.5v2.645H29.573V23.07A4.909,4.909,0,0,0,26.681,18.568ZM13.258,22.429c.148-.378.214-.641,1.5-1.134a13.839,13.839,0,0,1,9.923,0c1.265.493,1.331.756,1.5,1.134ZM19.715,9.286a1.643,1.643,0,1,1-1.643,1.643,1.648,1.648,0,0,1,1.643-1.643m0-3.286a4.929,4.929,0,1,0,4.929,4.929A4.922,4.922,0,0,0,19.715,6Z",
    transform: "translate(0 -6)",
    fill: "#1648c6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroup);
export default __webpack_public_path__ + "static/media/user-group.f2c7c457df4eff05308492a784042e00.svg";
export { ForwardRef as ReactComponent };